import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center">
      <div className="space-y-4 max-w-md">
        <h1 className="text-9xl font-extrabold text-primary tracking-widest">404</h1>
        <div className="bg-primary text-primary-foreground px-2 text-sm rounded rotate-12 absolute">
          Page Not Found
        </div>
        <h2 className="text-3xl font-bold text-foreground mt-4">الصفحة غير موجودة</h2>
        <p className="text-muted-foreground">
          الرابط الذي تحاول الوصول إليه غير متوفر حالياً أو تم نقله.
        </p>
        <button
          onClick={() => { window.location.hash = '#/'; }}
          className="mt-6 inline-block bg-primary text-primary-foreground px-6 py-3 rounded-xl font-bold hover:opacity-90 transition-opacity shadow-sm"
        >
          العودة للرئيسية / Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;